import axios from "axios";
import { API } from "../../const";
import { normParam } from "@/tools";

const M_API = API + "/api";
const store = {
  namespaced: true,
  state: {
    diklat_id: null,
    diklat: [],
    diklat_aktif: null,
    diklatTerpilih: null
  },
  getters: {
    diklat_aktif(state) {
      return state.diklat_aktif;
    },
    diklat_id(state) {
      return state.diklat_id;
    },
    diklat(state) {
      return state.diklat;
    },
    diklatTerpilih(state) {
      return state.diklatTerpilih;
    }
  },
  mutations: {
    pilihDiklat(state, diklat_aktif) {
      state.diklat_aktif = diklat_aktif;
    },
    setDiklat(state, val) {
      state.diklat_aktif = val;
    },
    setDiklatId(state, val) {
      state.diklat_id = val;
    },
    setDiklatTerpilih(state, val) {
      state.diklatTerpilih = val;
    }
  },
  actions: {
    // eslint-disable-next-line
    get({ state, commit }, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detail(_, { instansi_id, diklat_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getDiklats({ state }, instansi_id) {
      return axios.get(`${M_API}/instansi/${instansi_id}/diklats`).then(res => {
        state.diklat = res.data;
        return res.data;
      });
    },
    // eslint-disable-next-line
    getKelas({ state }, { instansi_id }) {
      return axios.get(`${M_API}/instansi/${instansi_id}/diklat_viewer`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    getDiklatku({ commit }, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklatku${normParam(params)}`)
        .then(res => {
          commit("main/setTotalInstansi", res.data.total, {
            root: true
          });
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    getMoodle(_, { instansi_id, kelas_id }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/self_enrol`, { kelas_id: kelas_id })
        .then(res => {
          return res.data;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    getPeran({ commit }, { instansi_id, diklat_id }) {
      if (diklat_id) {
        return axios
          .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/peran`)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      }
    },

    // eslint-disable-next-line
        getBidangStudi({ commit }, { instansi_id, diklat_id }) {
          if (diklat_id) {
            return axios
              .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/mapels_user`)
              .then(res => {
                return res.data;
              })
              .catch(err => Promise.reject(err));
          }
        },

    // eslint-disable-next-line
    getJenjang({ commit }, { instansi_id, diklat_id }) {
      if (diklat_id) {
        return axios
          .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/jenjang`)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      }
    },

    // eslint-disable-next-line
    konfigurasiPeran({ commit }, { instansi_id, diklat_id, jenis_diklat_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/konfigurasi`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    switchDiklat({ state, commit, dispatch }, { instansi_id, diklat_id }) {
      // cek apakah perlu load ulang instansi
      if (state.diklat_id == diklat_id) {
        return state.diklat_id;
      } else {
        return dispatch(
          "diklat/detail",
          {
            instansi_id: instansi_id,
            diklat_id: diklat_id
          },
          { root: true }
        ).then(res => {
          state.diklat_id = res.id;
          state.diklat_aktif = res;
        });
      }
    },

    // eslint-disable-next-line
    getJadwalsTs({ state }, { instansi_id, kelas_id }) {
      return axios.get(`${M_API}/instansi/${instansi_id}/rekaman/${kelas_id}`).then(res => {
        return res.data;
      });
    },

    form(_, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/diklat/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/diklat`, obj)
          .then(res => {
            // dispatch("akses", instansi_id);
            return res;
          })
          .catch(e => e);
      }
    },
    drop(_, { instansi_id, diklat_id }) {
      return axios.delete(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}`).then(res => {
        return res.data;
      });
    }
  }
};

export default store;
